import React, { useState, useEffect } from 'react'
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Col from 'react-bootstrap/Col';
import { Viewer, Worker } from "@react-pdf-viewer/core"
import { toolbarPlugin } from "@react-pdf-viewer/toolbar"
import "@react-pdf-viewer/core/lib/styles/index.css"
import "@react-pdf-viewer/toolbar/lib/styles/index.css"
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { courseDetailsRes, courseDetailsTodo } from '../../LMS_Redux/LMS_Slices/Course/CourseDetails';
import PropagateLoader from "react-spinners/PropagateLoader";

export default function CourseDetails(props) {

  const { state } = useLocation()
  const dispatch = useDispatch()
  const details = useSelector(state => state.courseDetails && state.courseDetails.data && state.courseDetails.data.data && state.courseDetails.data.data[0])
  const [loading, setLoading] = useState(false)
  // console.log('time', details)

  const [startQuiz, setStartQuiz] = useState(false)

  const toolbarPluginInstance = toolbarPlugin()
  const { Toolbar } = toolbarPluginInstance

  const details_res = () => {
    if (courseDetailsRes && courseDetailsRes.success) {
      setLoading(false)
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {

    props.setSidebar(false)
    setLoading(true)
    dispatch(courseDetailsTodo({ "course_id": state.id, "availability": state.course_availability })).then(() => details_res())

  }, [])

  return (
    <>

      <div className='container-fluid'>
        <div className='scnd-header align-items-center' style={{ justifyContent: 'space-between' }}>
          <div>
            <span className='icon1'>Learning Module Management / </span>
            <Link to={'/course_list'}><span className='icon2'>Learning Module List / </span></Link>
            <span className='icon2'>Learning Module Details - </span>
            <span className='icon2'>{!loading ? details && details.course_title + " -" : "loading.."} </span>
            <span className='icon2'>{!loading ? details && details.course_code : "loading.."} </span>
          </div>

          <div className='d-lg-flex mt-2 mt-lg-0'>

            <h6>Min. Viewing Time : {!loading ? details && details.min_view_time + "min" : 'loading..'} </h6>
            <h6 className='ms-lg-2'>Duration : {!loading ? details && details.duration + "days" : 'loading..'} </h6>

          </div>
        </div>


        {
          loading ?

            <div className='text-center mb-3'>
              <PropagateLoader
                color="#2262C6"
                size={20}
              />
            </div>

            :

            details ?
              <Tab.Container id="left-tabs-example" defaultActiveKey={details && details.lms_course_files && details.lms_course_files[0] && details.lms_course_files[0].id}>
                <Row>
                  <Col sm={3}>
                    <Nav variant="pills" className="flex-column" style={{ height: '70vh' }}>
                      <PerfectScrollbar>

                        {details && details.lms_course_files && details.lms_course_files.map((value, index) =>
                          <Nav.Item key={index}>
                            <Nav.Link eventKey={value.id}>
                              <h5 style={{ marginBottom: '0' }}>
                                {value.content_title}
                              </h5>
                              {/* <span className='badge bg-info'>Pending</span> */}
                            </Nav.Link>
                          </Nav.Item>
                        )}
                        <Nav.Item>
                          <Nav.Link eventKey="quiz">
                            <h5 style={{ marginBottom: '0' }}>View Quiz</h5>
                            {/* <span className='badge bg-warning'>Pending</span> */}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="description">
                            <h5 style={{ marginBottom: '0' }}>Description</h5>
                            {/* <span className='badge bg-warning'>Pending</span> */}
                          </Nav.Link>
                        </Nav.Item>

                      </PerfectScrollbar>
                    </Nav>
                  </Col>

                  <Col sm={9}>

                    <Tab.Content>

                      {details && details.lms_course_files && details.lms_course_files.map((value, index) =>
                        <Tab.Pane eventKey={value.id} key={index}>
                          <div className='wrapper-admin'>
                            <div className='text-center' style={{ height: '70vh' }}>

                              {(value.file_type == 'jpg') || (value.file_type == 'png') ?
                                <img src={process.env.REACT_APP_IMAGE_URL + (value.file_path || value.upload_file)} className='img-fluid' style={{ maxHeight: '100%' }} />
                                : ''}

                              {value.source == 'link' || value.source == 'vimeo' || value.file_type == 'mp4' ?
                                <iframe className='section2-video' id="videoFrame" src={value.link ? value.link : value.upload_file ? process.env.REACT_APP_IMAGE_URL + value.upload_file : value.file_path ? process.env.REACT_APP_IMAGE_URL + value.file_path : ''} title="YouTube video" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>
                                : ''}

                              {value.source == 'youtube' ?
                                <iframe className='section2-video' id="videoFrame" src={`https://www.youtube.com/embed/${value.link}`} title="YouTube video" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>
                                : ''}

                              {value.file_type == 'pptx' || value.file_type == 'ppt' ?
                                <iframe className='section2-video' id="videoFrame" src={value.file_path ? 'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.file_path : 'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.upload_file} title="ppt" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>
                                : ''}

                              {value.file_type == 'doc' || value.file_type == 'docx' ?
                                <iframe className='section2-video' id="videoFrame" src={'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.upload_file || 'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.file_path} title="Document" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>
                                : ''}

                              {/* {value.file_type == 'docx' ?
                                <iframe className='section2-video' id="videoFrame" src={'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.file_path} title="YouTube video" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>

                                : ''} */}

                              {value.file_type == 'pdf' ?
                                <div style={{ height: '70vh' }}>
                                  <PerfectScrollbar>
                                    <div className='d-flex justify-content-center' style={{ borderBottom: "2px solid rgba(0, 0, 0, 0.1)" }}>
                                      <Toolbar>
                                        {props => {
                                          const {
                                            CurrentPageInput,
                                            EnterFullScreen,
                                            GoToNextPage,
                                            GoToPreviousPage,
                                            NumberOfPages,
                                            Print,
                                            Zoom,
                                            ZoomIn,
                                            ZoomOut
                                          } = props
                                          return (
                                            <>
                                              <ZoomOut />
                                              <Zoom />
                                              <ZoomIn />
                                            </>
                                          )
                                        }}
                                      </Toolbar>
                                    </div>
                                    <div
                                      style={{
                                        flex: 1,
                                        overflow: "hidden"
                                      }}
                                    >
                                      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.10.111/build/pdf.worker.min.js">
                                        <Viewer
                                          fileUrl={process.env.REACT_APP_IMAGE_URL + (value.file_path || value.upload_file)}
                                          // renderPage={renderPage}
                                          plugins={[toolbarPluginInstance]}
                                        />
                                      </Worker>
                                    </div>
                                  </PerfectScrollbar>
                                </div>
                                : ''}

                            </div>
                          </div>
                        </Tab.Pane>
                      )}

                      <Tab.Pane eventKey="quiz">
                        <div className='wrapper-admin'>
                          <div style={{ height: '70vh' }}>
                            <PerfectScrollbar>
                              {!startQuiz ?
                                <div className='card mb-2'>
                                  <div className='card-header'>
                                    <span style={{ fontWeight: '500', fontSize: '16px' }}>Read Instructions Properly Before Quiz Start </span>
                                  </div>
                                  <div className='card-body'>
                                    <ul>
                                      <li>How to start the Quiz?</li>
                                      <li>What is the important points ?</li>
                                      <li>What about negative marking ?</li>
                                      <li>What if did not submit ?</li>
                                      <li>Full time of the quiz?</li>
                                      <li>How to start the Quiz?</li>
                                      <li>What is the important points ?</li>
                                      <li>What about negative marking ?</li>
                                      <li>What if did not submit ?</li>
                                      <li>Full time of the quiz?</li>
                                    </ul>

                                  </div>
                                  <div className='card-footer'>
                                    <div className='text-end'>
                                      <button className='btn btn_submit' type='button' onClick={() => setStartQuiz(true)}>View Questions</button>
                                    </div>
                                  </div>

                                </div>
                                : ''
                              }

                              {startQuiz ?

                                details && details.lms_course_quizzes && details.lms_course_quizzes.lms_quiz_sub_schemas && details.lms_course_quizzes.lms_quiz_sub_schemas.map((value, index) =>

                                  <div className='card mb-2' key={index}>
                                    <div className='card-header'>
                                      <span style={{ fontWeight: '500', fontSize: '16px' }}>{value.question} </span>
                                    </div>
                                    <div className='card-body' style={{ backgroundColor: 'aliceblue' }}>
                                      <div className="row">

                                        {(value && value.option1) || (value && value.image_option1) ?
                                          <div className="col-md-3">
                                            <div className="form-check">
                                              <input className="form-check-input form_checkbox" type="radio" name={"flexRadioDefault" + index} defaultChecked={value.correct_ans == 'A'} />
                                              {value.option1 &&
                                                <label className="form-check-label" htmlFor="">
                                                  {value.option1}
                                                </label>
                                              }
                                              {value.image_option1 &&
                                                <div style={{ height: '20vh' }}>
                                                  <img src={process.env.REACT_APP_IMAGE_URL + value.image_option1} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                </div>
                                              }
                                            </div>
                                          </div>
                                          : ''
                                        }

                                        {(value && value.option2) || (value && value.image_option2) ?
                                          <div className="col-md-3">
                                            <div className="form-check">
                                              <input className="form-check-input form_checkbox" type="radio" name={"flexRadioDefault" + index} defaultChecked={value.correct_ans == 'B'} />
                                              {value.option2 &&
                                                <label className="form-check-label" htmlFor="">
                                                  {value.option2}
                                                </label>
                                              }
                                              {value.image_option2 &&
                                                <div style={{ height: '20vh' }}>
                                                  <img src={process.env.REACT_APP_IMAGE_URL + value.image_option2} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                </div>
                                              }
                                            </div>
                                          </div>
                                          : ''
                                        }

                                        {(value && value.option3) || (value && value.image_option3) ?
                                          <div className="col-md-3">
                                            <div className="form-check">
                                              <input className="form-check-input form_checkbox" type="radio" name={"flexRadioDefault" + index} defaultChecked={value.correct_ans == 'C'} />
                                              {value.option3 &&
                                                <label className="form-check-label" htmlFor="">
                                                  {value.option3}
                                                </label>
                                              }
                                              {value.image_option3 &&
                                                <div style={{ height: '20vh' }}>
                                                  <img src={process.env.REACT_APP_IMAGE_URL + value.image_option3} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                </div>
                                              }
                                            </div>
                                          </div>
                                          : ''
                                        }

                                        {(value && value.option4) || (value && value.image_option4) ?
                                          <div className="col-md-3">
                                            <div className="form-check">
                                              <input className="form-check-input form_checkbox" type="radio" name={"flexRadioDefault" + index} defaultChecked={value.correct_ans == 'D'} />
                                              {value.option4 &&
                                                <label className="form-check-label" htmlFor="">
                                                  {value.option4}
                                                </label>
                                              }
                                              {value.image_option4 &&
                                                <div style={{ height: '20vh' }}>
                                                  <img src={process.env.REACT_APP_IMAGE_URL + value.image_option4} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                </div>
                                              }
                                            </div>
                                          </div>
                                          : ''
                                        }

                                        {(value && value.option5) || (value && value.image_option5) ?
                                          <div className="col-md-3">
                                            <div className="form-check">
                                              <input className="form-check-input form_checkbox" type="radio" name={"flexRadioDefault" + index} defaultChecked={value.correct_ans == 'E'} />
                                              {value.option5 &&
                                                <label className="form-check-label" htmlFor="">
                                                  {value.option5}
                                                </label>
                                              }
                                              {value.image_option5 &&
                                                <div style={{ height: '20vh' }}>
                                                  <img src={process.env.REACT_APP_IMAGE_URL + value.image_option5} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                </div>
                                              }
                                            </div>
                                          </div>
                                          : ''
                                        }

                                      </div>

                                    </div>

                                  </div>
                                )
                                : ''
                              }
                            </PerfectScrollbar>
                          </div>
                        </div>
                      </Tab.Pane>

                      <Tab.Pane eventKey="description">
                        <div className='wrapper-admin'>
                          <span style={{ color: '#7d7d7d' }}>Learning Module Description</span>
                          <p>{details && details.course_desc ? details.course_desc : '-'}</p>
                          <span style={{ color: '#7d7d7d' }}>Revise Reason</span>
                          <p>{details && details.revise_reason ? details.revise_reason : '-'}</p>
                        </div>
                      </Tab.Pane>

                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container >
              :
              <div className='wrapper-admin'>
                <div className='text-center'>
                  <h5>Learning Module Details not found</h5>
                </div>
              </div>
        }
      </div >

    </>
  )
}
